import { z } from 'zod';
import { es } from 'zod/locales';

// Mensajes de validación en español.
//
// Nuestros esquemas usan las restricciones de Zod sin texto propio
// (`z.string().min(1)`), así que el mensaje que ve el admin es el que trae la
// librería — y venía en inglés ("Too small: expected string to have >=1
// characters"), contra la regla de copy en español del proyecto. No es algo
// que rompió zod 4: en la v3 también estaba en inglés, con otra redacción.
//
// zod 4 incluye traducciones, así que alcanza con configurarlo UNA vez al
// arrancar. Los mensajes que sí están escritos a mano en un esquema siguen
// mandando: esto solo cambia el default.
export function initZodLocale(): void {
  z.config(es());
}
